/*
 * Enumeration of available API model types
 */
export enum ModelType {
  part = 'part',
  supplierpart = 'supplierpart',
  manufacturerpart = 'manufacturerpart',
  partcategory = 'partcategory',
  parttesttemplate = 'parttesttemplate',
  projectcode = 'projectcode',
  stockitem = 'stockitem',
  stocklocation = 'stocklocation',
  stocklocationtype = 'stocklocationtype',
  stockhistory = 'stockhistory',
  build = 'build',
  buildline = 'buildline',
  builditem = 'builditem',
  company = 'company',
  parameter = 'parameter',
  parametertemplate = 'parametertemplate',
  purchaseorder = 'purchaseorder',
  purchaseorderlineitem = 'purchaseorderlineitem',
  requestforquote = 'requestforquote',
  requestforquotelineitem = 'requestforquotelineitem',
  salesorder = 'salesorder',
  salesordershipment = 'salesordershipment',
  returnorder = 'returnorder',
  returnorderlineitem = 'returnorderlineitem',
  transferorder = 'transferorder',
  transferorderlineitem = 'transferorderlineitem',
  importsession = 'importsession',
  address = 'address',
  contact = 'contact',
  owner = 'owner',
  user = 'user',
  group = 'group',
  reporttemplate = 'reporttemplate',
  labeltemplate = 'labeltemplate',
  pluginconfig = 'pluginconfig',
  contenttype = 'contenttype',
  selectionlist = 'selectionlist',
  selectionentry = 'selectionentry',
  equipmentcategory = 'equipmentcategory',
  equipment = 'equipment',
  equipmentpmtask = 'equipmentpmtask',
  project = 'project',
  teamrole = 'teamrole',
  teammembership = 'teammembership',
  program = 'program',
  contractline = 'contractline',
  as9100documentcategory = 'as9100documentcategory',
  as9100document = 'as9100document',
  nonconformancereport = 'nonconformancereport',
  correctiveactionreport = 'correctiveactionreport',
  humanfactorsworksheet = 'humanfactorsworksheet',
  error = 'error',
  tag = 'tag'
}

export enum PluginPanelKey {
  // settings / admin
  admincenter = 'admincenter',
  systemsettings = 'systemsettings',
  usersettings = 'usersettings',
  // generic
  core = 'core',
  // landing pages
  purchasing = 'purchasing',
  sales = 'sales',
  manufacturing = 'manufacturing',
  // NIMS-specific landing pages
  as9100 = 'as9100',
  equipment = 'equipment',
  project = 'project',
  utilities = 'utilities'
}
